// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-xlargeOnWide-text-2728c005"};